<template>
  <span>{{ localizedValue }}</span>
</template>

<script setup>
import {computed} from 'vue';
import {useI18n} from 'vue-i18n';

const props = defineProps({
  value: {
    type: [String, Object],
    required: true
  }
});

const { locale } = useI18n();

// Computed property to return the localized value
const localizedValue = computed(() => {
  let parsedValue;

  // If the value is a string, attempt to parse it
  if (typeof props.value === 'string' && props.value.trim()) {
    try {
      parsedValue = JSON.parse(props.value); // Parse the string into an object
    } catch (error) {
      console.error('Error parsing JSON:', error);
      return 'Invalid translation data';
    }
  } else if (typeof props.value === 'object' && props.value !== null) {
    // If it's already an object, use it directly
    parsedValue = props.value;
  } else {
    // If value is neither valid string nor object
    return 'Invalid translation data';
  }

  const currentLocale = locale.value.trim();

  // Check if the key exists in the parsed JSON, otherwise default to 'en'
  if (parsedValue && typeof parsedValue === 'object') {
    return parsedValue[currentLocale] || parsedValue['en'] || '';
  }

  return '';
});
</script>
